import { SensorId } from "./types";
import { getLocale, i18n } from "./i18n";
import { translations } from "./translations";
import {
  HealthStatus,
  SENSOR,
  getHealthStatus,
  isHealthSensor,
} from "./sensors";

/**
 * Class with helper functions to get sensor labels and to translate raw values into human readable ones
 */
export class sensorInfo {
  static getLabel(sensorId: number, locale?: string) {
    const currentLocale = getLocale(locale);
    const labels = translations[currentLocale].sensorLabels;
    return labels[String(sensorId)] || sensorId.toString();
  }

  static getShortLabel(sensorId: number, locale?: string) {
    const currentLocale = getLocale(locale);
    const labels = translations[currentLocale].sensorLabelsShort;
    return labels[String(sensorId)] || sensorId.toString();
  }

  static getValue(
    sensorValue: string | number,
    sensorId: SensorId,
    locale?: string,
  ) {
    const currentLocale = getLocale(locale);

    if (isHealthSensor(sensorId)) {
      switch (getHealthStatus(sensorValue)) {
        case HealthStatus.Healthy:
          return i18n.t("ui:status.healthy", { lng: currentLocale });
        case HealthStatus.Unhealthy:
          return i18n.t("ui:status.unhealthy", { lng: currentLocale });
        case HealthStatus.NotConnected:
          return "-";
      }
    }

    if (sensorId === SENSOR.MobileSignalStrength) {
      const numericValue =
        typeof sensorValue === "number" ? sensorValue : Number(sensorValue);

      if (
        sensorValue === null ||
        sensorValue === undefined ||
        sensorValue === "" ||
        Number.isNaN(numericValue)
      ) {
        return "-";
      }

      return new Intl.NumberFormat(translations[currentLocale].intlLocale, {
        style: "percent",
      }).format(numericValue / 100);
    }

    const values = translations[currentLocale].sensorValues;
    if (typeof sensorValue === "string" && sensorValue in values) {
      return values[sensorValue as keyof typeof values];
    }

    return sensorValue;
  }
}
